{
  "es": {
    "ai": {
      "assistant": {
        "all_projects": "Todos los proyectos",
        "cap": {
          "action": "Iniciar una nueva conversación",
          "message": "Has alcanzado el límite de conversaciones."
        },
        "empty_state": {
          "subtitle": "Pregúntame lo que quieras sobre tus clientes",
          "title": "¿En qué puedo ayudarte?"
        },
        "errors": {
          "budget_reached": "El presupuesto de IA de este mes se ha agotado. Contacta con Ziggu para aumentarlo.",
          "generic": "Algo ha salido mal. Inténtalo de nuevo."
        },
        "history": {
          "empty": "Todavía no hay conversaciones anteriores",
          "title": "Conversaciones anteriores"
        },
        "input": {
          "disclaimer": "Los resultados pueden ser inexactos. Verifica siempre la información importante.",
          "hint": "Intro para enviar · Mayús+Intro para nueva línea",
          "placeholder": "Pregunta sobre tus clientes..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "¿Cómo configuro las notificaciones?",
          "help_project_settings": "¿Dónde encuentro la configuración del proyecto?",
          "open_decisions": "¿Qué decisiones siguen abiertas?",
          "unassigned_units": "¿Qué unidades todavía no tienen cliente?"
        },
        "support_cta": {
          "action": "Contactar con soporte",
          "prompt": "¿No es la respuesta que buscabas?"
        }
      },
      "settings": {
        "budget": {
          "description": "Límite de coste mensual para el uso de IA (fase de prueba). Se recalcula según el uso de tokens en todas las conversaciones de este mes.",
          "free_label": "Presupuesto gratuito",
          "override_help": "Déjalo vacío para usar el importe del paquete ({amount}).",
          "override_label": "Presupuesto gratuito personalizado",
          "paid_label": "Presupuesto de pago",
          "save": "Guardar",
          "title": "Presupuesto mensual",
          "total_label": "Presupuesto total",
          "usage_label": "Usado este mes",
          "use_package_amount": "Usar el importe del paquete"
        },
        "description": "Configuración de las funciones de IA en tu organización.",
        "title": "Configuración de IA",
        "usage": {
          "description": "Cuánto se ha usado del saldo de IA de este mes. Al llegar al 100 %, las funciones de IA se detienen hasta que el saldo se renueve el mes que viene.",
          "title": "Uso de IA"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Ajustar",
          "ask": "Preguntar",
          "draft": "Redactar una respuesta",
          "draft_empty": "Aún no hay mensajes a los que responder",
          "follow_up": "Seguimiento",
          "follow_up_stop": "Dejar de hacer seguimiento",
          "new": "Nueva pregunta",
          "summary": "Resumir la conversación",
          "summary_empty": "Aún no hay mensajes que resumir",
          "use_as_reply": "Usar como respuesta"
        },
        "adjusting_draft": "Ajuste de este borrador",
        "beta": "Beta",
        "budget": {
          "description": "El presupuesto de IA de este mes se ha agotado. Las respuestas anteriores siguen disponibles.",
          "request": "Hemos agotado el presupuesto de IA de este mes y queremos aumentarlo.",
          "request_low": "Casi hemos agotado el presupuesto de IA de este mes y queremos aumentarlo.",
          "title": "Presupuesto de IA alcanzado",
          "warn": "{percent} % del presupuesto de IA de este mes utilizado."
        },
        "cap": "Este chat se ha hecho largo. Mejor haz una pregunta nueva.",
        "collapse": "Ocultar asistente",
        "conversation": "Conversación",
        "digest": {
          "decisions_open": "ninguna decisión abierta | 1 decisión abierta | {count} decisiones abiertas",
          "installments_unpaid": "ninguna cuota impagada | 1 cuota impagada | {count} cuotas impagadas",
          "issues_open": "ninguna incidencia de posventa abierta | 1 incidencia de posventa abierta | {count} incidencias de posventa abiertas",
          "nothing_open": "Nada pendiente en esta unidad",
          "overdue": "{count} vencidas | {count} vencida | {count} vencidas",
          "title": "De un vistazo"
        },
        "earlier_answers": "Respuestas anteriores",
        "empty": "Pregunta algo sobre esta conversación o empieza con una de estas.",
        "expand": "Mostrar asistente",
        "following_up": "Seguimiento de esta respuesta",
        "footer": "Solo tú puedes verlo. Las respuestas las genera una IA y pueden contener errores.",
        "input": {
          "adjust_draft": "Ajusta este borrador, p. ej. más corto o más formal",
          "follow_up": "Haz una pregunta de seguimiento",
          "label": "Tu pregunta",
          "placeholder": "Pregunta por esta conversación"
        },
        "links": {
          "aftercare": "Posventa",
          "decisions": "Decisiones",
          "financials": "Finanzas"
        },
        "placeholders": {
          "confirm": {
            "accept": "Enviar igualmente",
            "header": "¿Enviar con datos sin completar?",
            "message": "El asistente dejó 1 dato sin completar en esta respuesta. | El asistente dejó {count} datos sin completar en esta respuesta."
          },
          "remaining": "1 dato por completar | {count} datos por completar"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Reemplazar",
            "header": "¿Reemplazar lo que escribiste?",
            "message": "El borrador reemplaza el texto del cuadro de respuesta."
          }
        },
        "suggestions": {
          "history": "¿Cuál es el historial con este cliente?",
          "issues_open": "¿Cuántas incidencias de posventa siguen abiertas?",
          "undecided": "¿Qué no ha decidido todavía este cliente?"
        },
        "thinking": "El asistente está trabajando...",
        "title": "Asistente"
      }
    }
  }
}
